import produce from "immer";

import { Policy } from "../../api/policy";
import {
  canEditPolicy,
  getPolicyCoverageData,
  getPolicyDetails,
  getPolicyDetailsHeader,
  getPolicyInsuredsData,
} from "./PolicyDetails.helpers";

export interface PolicyInsureds {
  insured: string;
  insuranceType: JSX.Element[];
  insuredAmount: string;
  premium: string;
  premiumPaymentTerm: string;
}

export interface PolicyInsuredsData {
  insureds: PolicyInsureds[];
  totalPremium: string;
}

interface PolicyDetails {
  key: string;
  value: string;
}

export interface PolicyCoverageData {
  totalPremium: string;
  paymentTerm: string;
  covers: {
    coverageData: {
      key: string;
      value: string;
    }[];
  }[];
}

export interface PolicyDetailsHeader {
  title: string;
  productName: string;
  policyNumber: string;
  insuranceTakers?: string[];
}

interface State {
  loading: boolean;
  canEdit: boolean;
  policyDetailsHeader: PolicyDetailsHeader | null;
  policyDetails: PolicyDetails[] | null;
  policyInsuredsData: PolicyInsuredsData | null;
  policyCoverageData: PolicyCoverageData | null;
  productCode: string | null;
  systemId: string | null;
}

export const initialState: State = {
  loading: false,
  canEdit: false,
  policyDetailsHeader: null,
  policyDetails: null,
  policyInsuredsData: null,
  policyCoverageData: null,
  productCode: null,
  systemId: null,
};

type Action =
  | { type: "FETCH_DATA" }
  | { type: "FETCH_SUCCESS"; payload: { data: { policy: Policy; dictionary: Record<string, string> } } }
  | { type: "FETCH_ERROR" };

export const policyDetailsReducer = (state: State, action: Action): State => {
  switch (action.type) {
    case "FETCH_DATA":
      return produce(state, (draft) => {
        draft.loading = true;
        draft.canEdit = false;
        draft.policyDetails = null;
        draft.policyInsuredsData = null;
        draft.productCode = null;
      });
    case "FETCH_SUCCESS":
      return produce(state, (draft) => {
        const { policy, dictionary } = action.payload.data;
        draft.loading = false;
        draft.canEdit = canEditPolicy(policy);
        draft.policyDetailsHeader = getPolicyDetailsHeader(policy, dictionary);
        draft.policyDetails = getPolicyDetails(policy);
        draft.productCode = policy.productCode;
        draft.systemId = policy.systemId;

        if (policy.productCode === "DUP" || policy.productCode === "UVATP") {
          draft.policyInsuredsData = getPolicyInsuredsData(policy, dictionary);
        }

        if (policy.productCode === "DLP") {
          draft.policyCoverageData = getPolicyCoverageData(policy);
        }
      });
    case "FETCH_ERROR":
      return produce(state, (draft) => {
        draft.loading = false;
      });
  }
};
